module.exports = __webpack_public_path__ + "0f789f7398d776cb7757a3155b13d8af.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/sandwich.png
// module id = 3044
// module chunks = 0